import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { integrationsService } from '@/services/integrations';
import type { GetPolicyBatchParams } from '@/services/integrations';

export function usePolicyBatch(params: GetPolicyBatchParams) {
  return useQuery({
    queryKey: ['policy-batch', params],
    queryFn: async () => {
      const response = await integrationsService.listPolicyBatch(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar balde de apólices');
      }
      return response.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 2,
  });
}
